import { useEffect, useState } from 'react';

export default (trigger: boolean, effect: () => void, deps: unknown[], resetOnTriggerFalse = true) => {
    const [hasChanged, setHasChanged] = useState<boolean>(false);

    useEffect(() => {
        if (trigger && !hasChanged) {
            effect();
            setHasChanged(true);
        }
        if (resetOnTriggerFalse && !trigger) {
            setHasChanged(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasChanged, resetOnTriggerFalse, trigger, effect, setHasChanged, ...deps]);
};
